var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallreys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.361,
    height: 56.56,
    viewBox: "0 0 59.361 56.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20090",
    "data-name": "Group 20090",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 102.804, 71.726)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44473",
    "data-name": "Path 44473",
    d: "M39.5,54.418C43.932,47.324,48.548,40.4,53.272,33.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44474",
    "data-name": "Path 44474",
    d: "M50.882,69.131c7.417-5.9,15.7-10.46,23.646-15.569",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44475",
    "data-name": "Path 44475",
    d: "M56.491,86.449c7.819-1.4,16.01-1.995,23.856-.71",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallreys);
export default __webpack_public_path__ + "static/media/smallreys.b297d5da5054bcb933d056190b1031f9.svg";
export { ForwardRef as ReactComponent };